import { connect } from 'react-redux';
import { getNumOfSubscribableItemsReqToCheckout } from '../selectors';

import { CheckoutButton } from '../components/sidebar/CheckoutButton';

const mapStateToProps = state => ({
  lineItemsProcessing: state.lineItemsProcessing,
  itemQuantity: state.currentOrder.total_quantity,
  numOfSubscribableItemsReqToCheckout: getNumOfSubscribableItemsReqToCheckout(
    state
  ),
  hasViolations: state.currentOrder.violations.length > 0,
});

export default connect(mapStateToProps)(CheckoutButton);
